import { render, staticRenderFns } from "./SurveyConfimation.vue?vue&type=template&id=3195e1ec"
import script from "./SurveyConfimation.vue?vue&type=script&lang=ts"
export * from "./SurveyConfimation.vue?vue&type=script&lang=ts"
import style0 from "./SurveyConfimation.vue?vue&type=style&index=0&id=3195e1ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports